import React from 'react'
import css from './style.scss'
import cn from 'classnames'

class Account extends React.Component{
  onClick(){
    if(!this.props.already_connected){
      this.props.onChoose({
        igId:this.props.instagram_business_account.id,
        pageId:this.props.id,
        token:this.props.access_token,
        name:this.state.account.name,
        info: {
          bio:this.state.account.biography,
          username: this.state.account.username,
          followers_count: this.state.account.followers_count,
          follows_count: this.state.account.follows_count,
          media_count: this.state.account.media_count,
        },
        picture:this.state.account.profile_picture_url,
      })
    }
  }
  constructor(props){
    super(props)
    this.state={
      loading:true
    }
  }
  componentDidMount(){
    if(!this.props.disabled){
      //console.log(this.props)
      window.FB.api('/'+this.props.instagram_business_account.id, { fields: 'biography,id,ig_id,followers_count,follows_count,media_count,name,profile_picture_url,username,website' }, (data) => {
        this.setState({account:data, loading:false})
      });
    }

  }
  render(){
    if(this.props.disabled){
      return(
        <div className={css.page}>
          <img alt={"Logo image for "+this.props.name} src={this.props.picture.data.url}></img>
          <div className={css.page_title}>{this.props.name}</div>
        </div>
      )
    }else{
      if(this.state.loading){
        return(
          <div className={cn(css.page, css.loadingPage)}>
            Loading...
          </div>
        )
      }else{
        return (
          <div className={cn(css.page, this.props.already_connected ? css.already_connected : "")} onClick={this.onClick.bind(this)}>
            <div className={css.img_wrapper}>
              <img alt={"Logo image for "+this.state.account.name} src={this.state.account.profile_picture_url}/>
              {this.props.already_connected && <div className={css.already_connected_message}>Already Connected</div>}
            </div>
            <div className={css.page_title}>{this.state.account.name}</div>
          </div>
        )
      }
    }

  }
}
class PageChooser extends React.Component{

  renderAccounts(){
    if(this.props.accounts.length>0){
      return (
        <div>
          <h4>Choose a Facebook page</h4>
          <div className={css.accountsContainer}>
            {this.props.accounts.filter(account=>account.instagram_business_account).map(account=><Account disabled={false} key={account.id} onChoose={this.props.onChoose} {...account}/>)}
          </div>
          {(this.props.accounts.filter(account=>!account.instagram_business_account)).length>0 && (
            <div>
              <h4 className={css.accountsDisabledTitle}>These pages doesn't have an associated Instagram account.</h4>
              <p>You can always add an Instagram account to a Facebook Business Page following this <a href="https://www.facebook.com/business/help/898752960195806" rel="noopener noreferrer" target="_blank">guide</a>.</p>
              <div className={cn(css.accountsContainer, css.disabled)}>
                {this.props.accounts.filter(account=>!account.instagram_business_account).map(account=><Account disabled={true} key={account.id} {...account}/>)}
              </div>
            </div>
          )}
        </div>
      )
    }else{
      return (
        <div className={css.noPages}>
          <h4>Seems like you don't have any Facebook Pages.</h4>
          <p>Are you sure this is the right Facebook account? </p>
        </div>
      )
    }
  }

  render(){
    return (
      <div>
          {this.renderAccounts()}
      </div>
    )
  }
}


export default PageChooser;



// WEBPACK FOOTER //
// ./src/components/setup/page_chooser.js